import React from 'react';
import styled from 'styled-components';
import { Spin, theme } from 'components';
import { buildCssProps } from 'utils';

export const StyledBodyPane = styled.div<{ $blur?: boolean }>`
  border: 1px solid #f0f0f0;
  border-radius: 2px;
  display: flex;
  flex-flow: column nowrap;
  align-items: start;
  padding: 36px;
  ${({ $blur }) =>
    buildCssProps([
      ['filter', $blur && `blur(${theme.pageBlurRadius})`],
      ['pointer-events', $blur && 'none'],
    ])}
`;

export const StyledPageContent = styled.div`
  width: 100%;
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
`;

export const PhoneBox = styled.div`
  background-color: #f0f7ff;
  border-radius: 6px;
  padding: 16px;
`;

export const PhoneLabel = styled.div`
  font-weight: 400;
  font-size: 18px;
  color: #585e72;
  padding-left: 8px;
  padding-top: 8px;
`;

export const PhoneNumber = styled.div`
  font-weight: 700;
  font-size: 24px;
  color: #1a1b21;
  padding-left: 8px;
`;

const StyledSpinnerContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 3.6rem;
  height: 20vh;
`;

export const StyledLoading = (
  <StyledSpinnerContainer>
    <Spin size="large" />
  </StyledSpinnerContainer>
);

export const TitleCircle = styled.div`
  width: 44px;
  height: 44px;
  min-width: 36px;
  background-color: #f0f7ff;
  border-radius: 50%;
  padding: 10px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
`;
